const traccar = require('./traccar')
const automaticReports = require('../automaticReports')
const traccarHelper = require('./traccar')
const { isInsideTimetable, isPartialInsideTimetable } = require('./trips')

// get devices used by each driver between two dates
async function devicesByDriver (traccarInstance, from, to, drivers, devices) {
  const eventsData = await traccar.getEvents(traccarInstance, from, to, devices, ['driverChanged'])
  const driverUniqueIdsToProcess = new Set(eventsData.map(e => e.attributes.driverUniqueId))
  const driversToProcess = drivers.filter(d => driverUniqueIdsToProcess.has(d.uniqueId))

  const deviceIdsToProcess = new Set(eventsData.map(e => e.deviceId))
  const devicesToProcess = devices.filter(d => deviceIdsToProcess.has(d.id))

  return { devices: devicesToProcess, drivers: driversToProcess }
}

async function reportByDriver (devices, traccar, from, to, userData, processor, allInOneData = { route: true, trips: true, stops: true, summary: false }) {
  const report = { drivers: [] }

  const sliced = automaticReports.sliceArray(devices, 5)

  let deviceCount = 0
  for (const slice of sliced) {
    const allInOne = await traccarHelper.getAllInOne(traccar, from, to, slice, allInOneData.route, allInOneData.trips, allInOneData.stops, allInOneData.summary, deviceCount, devices.length)
    const results = await processor(from, to, userData, { trips: allInOne.trips, route: allInOne.route, stops: allInOne.stops })
    report.drivers.push(...results)
    deviceCount = deviceCount + slice.length
  }

  return report
}

function getDriverUniqueIdTimeline (driverUniqueIdTimeline, driverUniqueId, date) {
  if (!driverUniqueIdTimeline) {
    return undefined
  }

  return driverUniqueIdTimeline.find(d => d.uniqueId === driverUniqueId &&
      (!d.startDate || new Date(d.startDate) <= new Date(date)) &&
      (!d.endDate || new Date(d.endDate) >= new Date(date)))
}

function getDriverName (driverUniqueId, date, userData) {
  if (driverUniqueId) {
    const timeline = getDriverUniqueIdTimeline(userData.driverUniqueIdTimeline, driverUniqueId, date)

    if (timeline) {
      return timeline.driverName
    }

    const driver = userData.drivers ? userData.drivers.find(d => !d.uniqueId.localeCompare(driverUniqueId, undefined, { sensitivity: 'base' })) : undefined

    return driver
      ? driver.name + ' ' + ((driver.attributes && driver.attributes.notes) || '')
      : driverUniqueId
  }

  return ''
}

async function getDriverData (d, data, userData) {
  const route = data.route ? data.route.filter(p => !d.uniqueId.localeCompare(p.attributes.driverUniqueId, undefined, { sensitivity: 'base' })) : undefined
  const trips = data.trips ? data.trips.filter(t => !d.uniqueId.localeCompare(t.driverUniqueId, undefined, { sensitivity: 'base' })) : undefined
  const events = data.events ? data.events.filter(e => e.position && !d.uniqueId.localeCompare(e.position.attributes.driverUniqueId, undefined, { sensitivity: 'base' })) : undefined

  const filteredTrips = []
  if (trips) {
    for (const t of trips) {
      if (userData.allWeek ||
          !userData.weekDays ||
          isInsideTimetable(t, userData) ||
          await isPartialInsideTimetable(t, userData, route)) {
        filteredTrips.push(t)
      }
    }
  }

  return {
    route,
    trips: filteredTrips,
    events
  }
}

exports.getDriverData = getDriverData
exports.getDriverName = getDriverName
exports.getDriverUniqueIdTimeline = getDriverUniqueIdTimeline
exports.devicesByDriver = devicesByDriver
exports.reportByDriver = reportByDriver
